import React from 'react';
import formatter from '../../utils/formatter';
import { withStyles, WithStyles, Theme } from '@material-ui/core/styles';
import { Setup } from '../setups/SetupsList';
import { VehicleInformation, Price } from '../main/motorcycles/MotorcycleView';
import { Part } from '../parts/PartsList';
import { withNamespaces, WithNamespaces } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';

export interface VehicleSummaryProps {
	appliedSetup: Setup | undefined;
	appliedParts: Part[];
	model: VehicleInformation;
	totalPrice: Price;
	hasPrices: boolean;
}

export const classes = (theme: Theme) => {
	return {
		priceClass: {
			color: theme.palette.primary.main,
			fontSize: '1.5em',
			display: 'inline' as "inline",
		},
		name: {
			color: 'white',
			fontSize: 35,
			lineHeight: '50px',
		},
		addOnCountBackground: {
			display: 'inline-block',
			background: theme.palette.primary.main,
			borderRadius: '50%',
			width: '26px',
			lineHeight: '26px',
			fontSize: '22px',
			textAlign: 'center' as "center",
			color: 'white',
			marginLeft: '1em',
			marginRight: '0.5em',
			position: 'relative' as "relative",
			top: '-2px'

		},
		addOn: {
			color: 'white',
			textTransform: 'initial' as "initial",
			fontSize: 'smaller' as "smaller",
		},
		addOnsWrapper: {
			display: 'inline-block',
		},
		count: {
			position: 'relative' as "relative",
			top: '1px',
		}
	}
}


export const VehicleSummary: React.FunctionComponent<VehicleSummaryProps & WithStyles & WithNamespaces> = props => {
	const { appliedParts, model, t, totalPrice, hasPrices } = props;
	const { priceClass, addOnCountBackground, addOn, name, addOnsWrapper, count } = props.classes;
	const addOnCountStyles: Record<string, React.CSSProperties> = {
		style: hasPrices ? {} : { marginLeft: 'initial' }
	}

	const uniqueAppliedParts = _.uniqBy(appliedParts, 'PartId')

	return (
		<div id="bike-summary">
			<div id="total-bike-price">
				{/* REVERT WHEN SETUPS ARE ACTIVE */}
				{/* {appliedSetup && */}
				{true &&
					<h3 className={priceClass} >
						{hasPrices && <span>{t('configurationDetail.total')} {true /*appliedSetup*/ && formatter.currency(totalPrice)}</span>}
						<div className={addOnsWrapper}>
							<span {...addOnCountStyles} className={addOnCountBackground}>
								<span className={count}>{uniqueAppliedParts.length}</span>
							</span>
							<span className={addOn}>{t('configurationDetail.addOns')}</span>
						</div>
					</h3>}
				<Grid container justify="space-between" alignItems="flex-end">
					<h3 className={name}>{model.Name}</h3>
					<div>{props.children}</div>
				</Grid>
			</div>
		</div>
	);
}

export default withNamespaces()(withStyles(classes)(VehicleSummary));
